import type { TaskLogEntry, TaskStatus } from "../../types";

import { COLOR_BG } from "../common/colorTokens";

export const NAV_ITEMS = [
  { descriptor: "Overview", key: "overview", label: "Dashboard" },
  { descriptor: "Statistics", key: "usage", label: "Statistics" },
  { descriptor: "Plans", key: "plans", label: "Plan Snapshots" },
  { descriptor: "Arena", groupHeader: true, key: "agents", label: "Arena" },
  {
    descriptor: "Live",
    key: "agents-instances",
    label: "Fleet",
    parent: "agents",
  },
  {
    descriptor: "Presets",
    key: "agents-templates",
    label: "Templates",
    parent: "agents",
  },
  {
    descriptor: "Repo Chat",
    featureFlag: "repository_chat",
    key: "repo-chat",
    label: "Repository Chat",
  },
  { descriptor: "Integrations", key: "integrations", label: "Integrations" },
  { descriptor: "Config", key: "settings", label: "Settings" },
  { descriptor: "Platform", key: "admin", label: "Admin", section: "admin" },
  { descriptor: "Know-How", key: "wiki", label: "Know-How", section: "info" },
  {
    descriptor: "Changelog",
    key: "release-notes",
    label: "Release Notes",
    section: "info",
  },
] as const;

export type NavKey = (typeof NAV_ITEMS)[number]["key"];

export const STATUS_LABELS: Record<TaskStatus, string> = {
  canceled: "Canceled",
  cancelled: "Cancelled",
  failed: "Failed",
  queued: "Queued",
  running: "Running",
  skipped: "Skipped",
  succeeded: "Succeeded",
};

export const LEVEL_BADGE_CLASS: Record<TaskLogEntry["level"], string> = {
  debug: "bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-white/60",
  error: `${COLOR_BG.rose} text-rose-700 dark:text-rose-100`,
  info: `${COLOR_BG.slate} text-slate-700 dark:text-slate-100`,
  warn: `${COLOR_BG.amber} text-amber-700 dark:text-amber-100`,
};
